__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "freya_project_request_ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.11.4", () => (Promise.all([__webpack_require__.e(5886), __webpack_require__.e(326), __webpack_require__.e(6207)]).then(() => (() => (__webpack_require__(90326))))));
			register("@emotion/styled", "11.11.0", () => (Promise.all([__webpack_require__.e(6109), __webpack_require__.e(6207), __webpack_require__.e(7212)]).then(() => (() => (__webpack_require__(56109))))));
			register("@mui/material", "5.15.12", () => (Promise.all([__webpack_require__.e(501), __webpack_require__.e(5886), __webpack_require__.e(8591), __webpack_require__.e(7750), __webpack_require__.e(2590), __webpack_require__.e(1177), __webpack_require__.e(4031), __webpack_require__.e(4161), __webpack_require__.e(8773), __webpack_require__.e(1349), __webpack_require__.e(6207), __webpack_require__.e(7212), __webpack_require__.e(8034), __webpack_require__.e(579)]).then(() => (() => (__webpack_require__(11349))))));
			register("@rjsf/core", "5.24.13", () => (Promise.all([__webpack_require__.e(7015), __webpack_require__.e(9315), __webpack_require__.e(2366), __webpack_require__.e(4530), __webpack_require__.e(6207), __webpack_require__.e(8514), __webpack_require__.e(2960)]).then(() => (() => (__webpack_require__(24530))))));
			register("@rjsf/mui", "5.24.13", () => (Promise.all([__webpack_require__.e(501), __webpack_require__.e(5886), __webpack_require__.e(8591), __webpack_require__.e(2590), __webpack_require__.e(1177), __webpack_require__.e(4161), __webpack_require__.e(6128), __webpack_require__.e(6207), __webpack_require__.e(8514), __webpack_require__.e(7212), __webpack_require__.e(8034), __webpack_require__.e(820), __webpack_require__.e(5817)]).then(() => (() => (__webpack_require__(56128))))));
			register("@rjsf/utils", "5.24.13", () => (Promise.all([__webpack_require__.e(7015), __webpack_require__.e(9030), __webpack_require__.e(9315), __webpack_require__.e(2366), __webpack_require__.e(2681), __webpack_require__.e(6207)]).then(() => (() => (__webpack_require__(42681))))));
			register("@rjsf/validator-ajv8", "5.24.13", () => (Promise.all([__webpack_require__.e(7015), __webpack_require__.e(443), __webpack_require__.e(8514)]).then(() => (() => (__webpack_require__(40443))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(6207)]).then(() => (() => (__webpack_require__(97950))))));
			register("react", "18.2.0", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};